module.exports = __webpack_public_path__ + "static/media/level-down.e085190d.svg";